module.exports = "data:image/svg+xml;base64,PHN2ZyBjbGFzc05hbWU9J2hlYWRlci1iYWNrLWNhcmV0JyB3aWR0aD0iMjAiIGhlaWdodD0iIiB2aWV3Qm94PSI5NjcgMzggOSA2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTk3NC42OCAzOGwuOTYuOTYtNC4zMiA0LjMyLTQuMzItNC4zMi45Ni0uOTYgMy4zNiAzLjM2eiIvPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/caret-white.svg
// module id = 321
// module chunks = 0